import Constants from 'arts/config/constants';

export const expand = (key) => ({
  type: Constants.Expandable.ACTIONS.expand,
  key
});
